<template>
  <div></div>
</template>
<script>
export default {
  mounted() {
    // if we got to this page then send over to the default page: batch-history
    this.$router.push("/sso-login");
  },
};
</script>
